import { TrialIntegrationType } from '@approvalmax/ui/src/components/complex';
import { selectors, useSortedCompanies } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useMemo } from 'react';

export const useGetCompanies = () => {
    const allCompanies = useSortedCompanies();

    return useMemo(
        () =>
            allCompanies.reduce((companies, company) => {
                if (
                    company.allFeaturesTrialStatus !== domain.AllFeaturesTrialStatus.AwaitingActivation &&
                    company.allFeaturesTrialStatus !== domain.AllFeaturesTrialStatus.Expired
                ) {
                    return companies;
                }

                if (company.integration?.integrationType === domain.IntegrationType.Xero) {
                    return [
                        ...companies,
                        {
                            id: company.id,
                            name: company.name,
                            integrationType: TrialIntegrationType.Xero,
                            isNotManager: !company.flags.isManager,
                            allFeaturesTrialStatus: company.allFeaturesTrialStatus,
                            licenseProductPlan: company.licenseProductPlan,
                        },
                    ];
                } else if (company.integration?.integrationType === domain.IntegrationType.QBooks) {
                    return [
                        ...companies,
                        {
                            id: company.id,
                            name: company.name,
                            integrationType: TrialIntegrationType.Quickbooks,
                            isNotManager: !company.flags.isManager,
                            allFeaturesTrialStatus: company.allFeaturesTrialStatus,
                            licenseProductPlan: company.licenseProductPlan,
                        },
                    ];
                }

                return companies;
            }, []),
        [allCompanies]
    );
};

export const useGetRedirectTemplate = (companyId: string) => {
    const companyTemplates = useSelector((state) => selectors.template.getAllTemplatesByCompanyId(state, companyId));

    const template = companyTemplates.find(
        (template) =>
            template.integrationCode === domain.IntegrationCode.XeroBill ||
            template.integrationCode === domain.IntegrationCode.QBooksBill
    );

    return template;
};
